import { SyntheticEvent, useContext, VFC } from "react";
// Libraries
import cn from "classnames";
import SVG from "react-inlinesvg";
// Utils
import { DropdownMenuContext } from "../";
// Resources
import styles from "../DropdownMenu.module.scss";

interface DropdownMenuActionProps {
  colour?: string;
  icon?: string;
  isActive?: boolean;
  onClick: (event: SyntheticEvent<HTMLButtonElement>) => void;
  text: string;
}

export const DropdownMenuAction: VFC<DropdownMenuActionProps> = ({ colour, icon, isActive, onClick, text }) => {
  const { handleClose } = useContext(DropdownMenuContext);

  const handleClick = (event: SyntheticEvent<HTMLButtonElement>): void => {
    onClick(event);
    handleClose?.();
  };

  return (
    <button
      className={cn(styles.dropdown_menu__item, { [styles["dropdown_menu__item--active"]]: isActive })}
      disabled={isActive}
      onClick={handleClick}
      style={{ color: `${colour}` }}
    >
      {icon && (
        <span className={styles.dropdown_menu__item_icon}>
          <SVG src={icon} />
        </span>
      )}

      <span className={styles.dropdown_menu__item_caption}>{text}</span>
    </button>
  );
};
